<template>
  <div class="fl-header-profile">
    <ui-button-select
      v-if="!loadingUser"
      :list="menu"
      :min-width="220"
      :has-arrow="false"
      button-style="link"
    >
      <div class="fl-header-profile__content">
        <img
          class="fl-header-profile__avatar"
          v-if="userAvatar?.url"
          :src="userAvatar.url"
          alt=""
        >
        <ui-icon
          class="fl-header-profile__empty-avatar"
          v-else
          :size="24"
          type="primary"
          name="uiProfile"
        />
        <div class="fl-header-profile__title">
          {{ userName }}
        </div>
      </div>
    </ui-button-select>
    <ui-skeleton
      v-else
      :width="100"
      text
    />
  </div>
</template>

<script>
import UiSkeleton from "@iflat-ui/components/skeleton/UiSkeleton.vue"
import UiButtonSelect from "@iflat-ui/components/UiButtonSelect.vue";
import UiIcon from "@iflat-ui/components/icons/UiIcon";

import {useUserStore} from "@/modules/User/store/user";

import {getInitial} from "@iflat-ui/libs/helpTools";
export default {
  components: {UiSkeleton, UiButtonSelect, UiIcon},
  data() {
    return {
      userStore: useUserStore()
    }
  },
  computed: {
    menu() {
      return [
        {
          id: 'exit',
          name: 'Выход ',
          event: this.userStore.logout,
        }
      ]
    },
    loadingUser() {
      return this.userStore.loadingUser
    },
    user() {
      return this.userStore.user
    },
    userAvatar() {
      return this.userStore.userAvatar
    },
    userName() {
      if(!this.user) return ''
      return `${this.user.first_name} ${getInitial(this.user.last_name)}`
    }
  }
}
</script>

<style lang="scss" scoped>
.fl-header-profile {
  ::v-deep(.ui-button-select__button) {
    text-decoration: none !important;

    &:hover {
      color: $primary;
    }
  }

  ::v-deep(.ui-button-select__dropdown) {
    margin-top: 18px;
  }

  &__content {
    @include flex-center;
  }

  &__avatar {
    height: 35px;
    width: 35px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
  }

  &__empty-avatar {
    margin-right: 10px;
  }
}
</style>
